/** angular */
import { Injectable } from '@angular/core';
/** end angular */

/** models */
import { DsFormInstanceWithTemplate } from '../models/ds-form-instance-with-template';
/** end models */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** end services */

/** interfaces */
import { DsFormInstanceWithTemplateInterface } from '../interfaces/form-instance/ds-form-instance-with-template.interface';
import { Observable } from 'rxjs';
/** end interfaces */

/** Sixense */
import { BydHttpParams } from '@sixense/byd-core-service';
import { DsFormInstanceEdit } from '../models/ds-form-instance-edit';

@Injectable({
  providedIn: 'root',
})
export class DsFormInstanceService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get a form instance with its template.
   *
   * @param projectId The project id
   * @param instanceId The form instance id
   * @param templateSchema Whether to include the template schema
   * @returns The form instance with its template
   *
   * (todo: merge DsFormInstance classes & interfaces with the DsFormInstanceWithTemplate)
   */
  public getFormInstance(projectId: number, instanceId: number, templateSchema = true) {
    this.path = `/v2/projects/${projectId}/instances/${instanceId}`;
    const params = new BydHttpParams().set('templateSchema', templateSchema.toString());
    return this.getModel<DsFormInstanceWithTemplate>({ params });
  }

  /**
   * Delete a form Instance.
   *
   * @param projectId the project id
   * @param instanceId The form instance id
   * @returns Observable<boolean>
   */
  public deleteFormInstance(projectId: number, instanceId: number): Observable<boolean> {
    this.path = `/v2/projects/${projectId}/instances/${instanceId}`;
    return this.delete<boolean>();
  }

  /**
   * Create DsFormInstanceWithTemplate instance.
   *
   * @param json The json response.
   * @returns an `DsFormInstanceWithTemplate` instance.
   */
  public createNewInstance(json: DsFormInstanceWithTemplateInterface): DsFormInstanceWithTemplate {
    return new DsFormInstanceWithTemplate(json);
  }

  /**
   * Edit the form instance.
   *
   * @param projectId the project id
   * @param instanceId the instance id
   * @param formInstance DsFormTemplate
   * @returns Observable<boolean>
   */
  public editFormInstance(
    projectId: number,
    instanceId: number,
    formInstance: DsFormInstanceEdit
  ): Observable<boolean> {
    this.path = `/v2/projects/${projectId}/instances/${instanceId}`;
    return this.putModel<boolean>({ body: formInstance });
  }
}
